import renderBiz from './wxs/renderjs.js';
export default {
	mixins: [renderBiz]
}